import routerOptions0 from "/home/boristane/boristane/zirp/node_modules/.pnpm/nuxt@3.13.2_@biomejs+biome@1.9.4_@parcel+watcher@2.4.1_@types+node@20.14.2_eslint@9.11.1_jiti_mk34axq4lpi2m2kplkyyqfslby/node_modules/nuxt/dist/pages/runtime/router.options";
import routerOptions1 from "/home/boristane/boristane/zirp/node_modules/.pnpm/@nuxt+ui-pro@1.4.3_axios@1.7.7_magicast@0.3.5_rollup@4.22.5_ts-node@10.9.2_@types+node@20.14._igc4x6fdh2p6trq625thpjjsbu/node_modules/@nuxt/ui-pro/modules/pro/runtime/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}